<template>
  <div class="sys-menu-page main-layout">
    <el-card class="box-outter">
      <c-title slot="header" title="菜单管理" :back="false"></c-title>
      <el-card class="box-table box-inner" shadow="never">
        <div slot="header" class="btn-group">
          <div class="btn-left">
            <div class="opt-btn" title="新增" @click="goto('')">
              <i class="iconfont icon-add"></i>
            </div>
          </div>
          <!-- 右侧操作按钮 -->
          <table-btns
            :tableColumns="tableColumns"
            @tableColumnsChange="tableColumnsChange"
            @refresh="getTableTree"
          ></table-btns>
        </div>
        <div class="div-scroll">
          <el-table
            :data="tableData"
            style="width: 100%"
            row-key="id"
            border
            lazy
            v-loading="pageLoading"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          >
            <template v-for="item in tableColumns">
              <el-table-column
                v-if="item.show"
                :key="item.label"
                :label="item.label"
                :align="item.align || 'center'"
                header-align="center"
                :width="item.width"
                :prop="item.prop"
              >
              </el-table-column>
            </template>
            <el-table-column
              label="是否启用"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.isDelete == 0 ? "启用" : "停用" }}
              </template>
            </el-table-column>
            <el-table-column
              label="是否缓存"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.isAlive == 1 ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column
              label="类型"
              header-align="center"
              min-width="50px"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag :type="types[Number(scope.row.type)].type">{{
                  types[Number(scope.row.type)].label
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" width="180px">
              <template slot-scope="scope">
                <div class="contr-btn-group">
                  <div
                    class="contr-btn"
                    title="添加下级"
                    @click="goto(scope.row, 'add')"
                  >
                    <i class="iconfont icon-xiaji"></i>
                  </div>
                  <div
                    class="contr-btn"
                    title="编辑"
                    @click="goto(scope.row, 'edit')"
                  >
                    <i class="iconfont icon-edit"></i>
                  </div>
                  <div
                    class="contr-btn"
                    title="设置"
                    @click="gotoSetting(scope.row)"
                  >
                    <i class="iconfont icon-setting" style="color:#1890ff"></i>
                  </div>
                  <div
                    class="contr-btn"
                    title="删除"
                    @click="handleDeleteMenu(scope.row.id)"
                  >
                    <i class="iconfont icon-shanchu"></i>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
    >
      <div class="div-scroll" style="max-height: 500px; padding: 0 4%">
        <div v-loading="handleLoading">
          <c-form
            v-if="dialogType == 'form'"
            v-model="handleData"
            :formRules="formRules"
            label-width="150px"
            ref="cForm"
            @submit="submit"
            @resetFields="resetFields"
          >
            <el-form-item label="类型">
              <el-radio-group v-model="handleData.type">
                <el-radio
                  v-for="(item, index) in types"
                  :key="index"
                  :label="item.value"
                >
                  <el-tag :type="item.type">{{ item.label }}</el-tag>
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="上级菜单名称" prop="parentId">
              <select-tree
                v-model="handleData.parentId"
                :options="tableData"
                :props="tree.props"
              />
            </el-form-item>
            <c-form-item :formItems="formItems" />
          </c-form>
          <c-form
            v-else
            v-model="settingForm"
            :formItems="formItems_setting"
            :formRules="formRules_Setting"
            label-width="150px"
            ref="cForm"
            @submit="submit_setting"
            @resetFields="resetFields"
          ></c-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MHandle from "@/mixins/MHandle.js";
import SelectTree from "@/components/SelectTree";
import Configs from "./data/menu";
import { mapState } from "vuex";
let mHandle = MHandle({
  handleGetPath: "",
  handleInsertPath: "/account/sys/menu/save",
  handleUpdatePath: "/account/sys/menu/update",
  handleDownLoadPath: "",
  handleData: {},
});
export default {
  components: {
    SelectTree,
  },
  mixins: [mHandle],
  data() {
    let {
      tableColumns,
      formItems,
      formRules,
      formItems_setting,
      formRules_Setting,
      tree,
      types,
    } = Configs(this);
    return {
      formItems,
      formRules,
      tableColumns,
      formItems_setting,
      formRules_Setting,
      tree,
      types,
      dialogFormVisible: false,
      title: "",
      tableData: [],
      pageLoading: false,
      defaultProps: {
        children: "children",
        label: "name",
      },
      defaultHandleData: {
        icon: "", // 菜单图标
        level: "", // 菜单层级
        name: "", // 菜单名称
        parentId: "", // 父id
        sort: 1, // 排序
        perms: "", // 菜单权限标识
        type: 0, // 菜单类型
        url: "", // 菜单url
        platform: "", // 平台标识
        component: "", // 菜单组件
        isDelete: "0",
        isAlive: 0,
      },
      dialogType: "",
      settingForm: { id: "", flag: [] },
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE", "_APP_KEY"]),
  },
  created() {},
  mounted() {
    // 获取表格数据
    this.getTableTree();
  },
  methods: {
    // 刷新表格
    refresh() {
      this.getTableTree();
    },
    // 表格展示列动态改变
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    // 打开新增或编辑弹框
    goto(data, type) {
      this.dialogType = "form";
      let id = data.id;
      this.dialogFormVisible = true;
      this.handleData = Object.assign({}, this.defaultHandleData);
      if (id) {
        if (type == "add") {
          this.title = "添加";
          this.handleData.parentId = id;
        } else {
          this.title = "编辑";
          this.handleData = Object.assign({}, data);
        }
      } else {
        this.title = "添加";
      }
    },
    // 获取树状结构表格数据
    getTableTree() {
      this.pageLoading = true;
      this.$http
        .get("/account/sys/menu/getTreeList", {
          params: { platform: this._APP_KEY },
        })
        .then((res) => {
          console.log(res);
          this.pageLoading = false;
          if (res.code == this.SUCCESS_CODE) {
            this.tableData = res.data;
          } else {
            this.$message.error(`获取数据失败，${res.msg}`);
          }
        })
        .catch((err) => {
          this.pageLoading = false;
          this.$message.error(`获取数据失败，${err}`);
        });
    },
    // 删除单项菜单
    handleDeleteMenu(id) {
      let title = "此操作将永久删除该数据, 是否继续?";
      this.$confirm(title, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$http
            .get(`/account/sys/menu/` + id, {
              headers: {
                "X-HTTP-Method-Override": "DELETE",
              },
            })
            .then((res) => {
              console.log(res);
              if (res.code == this.SUCCESS_CODE) {
                this.$message({
                  message: "恭喜你，删除成功！",
                  type: "success",
                });
                // 删除成功后重新获取表格数据
                this.getTableTree();
              } else {
                this.$message.error(`删除数据失败，${res.msg}`);
              }
            })
            .catch((err) => {
              this.$message.error(`删除数据失败，${err}`);
            });
        })
        .catch((err) => (err) => console.warn(err));
    },
    handleDialogClose() {
      this.handleData = Object.assign({}, this.defaultHandleData);
    },
    resetFields() {
      this.dialogFormVisible = false;
    },
    submit() {
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        this.handleInsert();
      }
    },
    handleAfterFn() {
      this.dialogFormVisible = false;
      this.getTableTree();
    },
    // 树节点点击事件
    handleNodeClick(data) {
      console.log(data);
      this.parentName = data.name;
      this.parentId = data.id;
      this.isSelcetTree = false;
    },
    gotoSetting(data) {
      this.dialogType = "setting";
      this.settingForm.id = data.id;
      this.settingForm.flag = data.flag ? data.flag.split(",") : [];
      this.title = "学生端菜单标识";
      this.dialogFormVisible = true;
    },
    submit_setting() {
      this.handleLoading = true;
      this.$http
        .post(
          "/account/sys/menu/setFlag/" + this.settingForm.id,
          this.settingForm.flag
        )
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            // console.log(res);
            this.handleAfterFn();
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
          this.handleLoading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.handleLoading = false;
        });
    },
  },
};
</script>

